import React, { useContext, useEffect, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Button, Modal } from 'semantic-ui-react';

import '../../css/TakeAsStudentModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

const TakeAsStudentModal = observer((props) => {
  const { classroomId, onClose, onConfirm, open, t } = props;

  const { classroomManager } = useContext(MobXProviderContext);

  const SatCoreLoader = SatCoreComponent('SatCoreLoader');
  const ModalBanner = SatCoreComponent('ModalBanner');

  const [loading, setLoading] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  useEffect(() => {
    if (open && classroomId) {
      const existingRoster = classroomManager.rosterMap.get(classroomId);
      if (!existingRoster || existingRoster.length === 0) {
        setLoading(true);
        classroomManager.fetchClassroomRoster(classroomId).finally(() => setLoading(false));
      }
    }
    if (!open) {
      setSelectedStudentId(null);
    }
  }, [open, classroomId]);

  const roster = classroomManager.rosterMap.get(classroomId) || [];

  const handleOk = () => {
    const student = roster.find((s) => s.userId === selectedStudentId);
    if (student) {
      onConfirm(student);
    }
  };

  return (
    <Modal
      className='take-as-student-modal'
      closeOnDimmerClick={false}
      onClose={onClose}
      open={open}
      size='small'>
      <ModalBanner
        label={t('takeAsStudentModalHeader', 'Take as Student')}
        onClose={onClose} />
      <Modal.Content>
        <p className='take-as-student-prompt'>
          {t('takeAsStudentModalPrompt', 'Select a student to complete work for:')}
        </p>
        {loading ? (
          <SatCoreLoader height='200px' t={t} />
        ) : roster.length === 0 ? (
          <p className='take-as-student-empty'>
            {t('takeAsStudentModalEmpty', 'No students found for this class.')}
          </p>
        ) : (
          <>
            <div className='take-as-student-roster-header'>
              {t('takeAsStudentModalRosterLabel', 'Class Roster')}
            </div>
            <div className='take-as-student-roster'>
              {roster.map((student) => {
                const isSelected = student.userId === selectedStudentId;
                return (
                  <div
                    key={student.userId}
                    className={`take-as-student-row${isSelected ? ' selected' : ''}`}
                    onClick={() => setSelectedStudentId(student.userId)}
                    role='radio'
                    aria-checked={isSelected}
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && setSelectedStudentId(student.userId)}>
                    <input
                      className='take-as-student-radio'
                      readOnly
                      checked={isSelected}
                      type='radio' />
                    <span>{student.lastName}, {student.firstName}</span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button basic className='cancelButton' onClick={onClose} primary type='button'>
          {t('takeAsStudentModalCancel', 'Cancel')}
        </Button>
        <Button
          disabled={!selectedStudentId}
          onClick={handleOk}
          primary
          type='button'>
          {t('takeAsStudentModalOk', 'OK')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});

SatCoreRegister('TakeAsStudentModal', TakeAsStudentModal);

export default TakeAsStudentModal;
